import styled, { css } from 'styled-components';
import { FiAlertCircle, FiCheckCircle } from 'react-icons/fi';

import theme from '../../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${({ width }) =>
    width &&
    css`
      width: ${width}px;
    `};
`;

export const ContentText = styled.div`
  color: ${theme.movGrey};
  padding: 27px 0;
  align-self: center;
  font: normal normal normal 14px/20px 'Calibri';

  strong {
    font: bold 15px 'Calibri';
  }

  a,
  a:hover {
    font: bold 14px 'Calibri';
    color: #8bac2a;
    text-decoration: none;
  }
`;

export const ContentFile = styled.div`
  margin: 10px;
`;

export const IconAlert = styled(FiAlertCircle)`
  color: ${theme.yellowDefault};
  width: 17px;
  height: 17px;
  margin-right: 15px;
`;

export const IconsSuccess = styled(FiCheckCircle)`
  color: ${theme.greenDefault};
  width: 17px;
  height: 17px;
  margin-right: 15px;
`;
